<template>
    <main>
        <header class="has-text-centered">
            <div class="is-flex is-align-items-center is-justify-content-center mt-5 mb-6">
                <Logo />
                <img style="margin-left: 150px;" :src="chitaLogo" />
            </div>
            <h1 class="is-size-3 has-text-weight-bold mb-1">
                CFOREMOTO Y CHITA SE UNEN PARA AYUDARTE
            </h1>
            <p class="is-size-5 mb-5 pb-3">
                A OPTIMIZAR EL MANEJO DE CAJA DE TU NEGOCIO.
            </p>
            <p
                class="is-size-5 py-3 has-text-white"
                style="
          background-image: linear-gradient(90deg, #00a9ad 0%, #1878e8 100%);
        "
            >
                Obtén
                <span class="has-text-weight-bold">GRATIS el Plan Basic</span>
                de CFOremoto para tener orden, análisis, proyecciones y financiamiento
            </p>
        </header>
        <main
            class="container py-6 is-align-items-center"
            style="display: grid; grid-template-columns: 1fr 1fr; gap: 80px;"
        >
            <div>
                <img :src="illustration" />
                <p class="is-size-4 mt-5 has-text-income has-text-centered">
                    Maneja las finanzas de tu empresa con el software de CFOremoto
                </p>
            </div>
            <div>
                <ValidationObserver
                    ref="observer"
                    v-slot="{ handleSubmit }"
                    style="grid-template-columns: 1fr 1fr; display: grid; gap: 24px;"
                >
                    <div>
                        <label class="label has-text-weight-bold" for="name">
                            Nombre
                        </label>
                        <Input
                            type="text"
                            placeholder="María Paz"
                            name="nombre"
                            ref="first_name"
                            v-model="user.first_name"
                            rules="required|min:1|max:49"
                            disabled
                        />
                    </div>
                    <div>
                        <label class="label has-text-weight-bold" for="apellido">
                            Apellido
                        </label>
                        <Input
                            type="text"
                            placeholder="Fuenzalida"
                            name="apellido"
                            ref="last_name"
                            v-model="user.last_name"
                            rules="required|min:1|max:99"
                            disabled
                        />
                    </div>
                    <div>
                        <label class="label has-text-weight-bold" for="email">
                            Email
                        </label>
                        <Input
                            type="text"
                            placeholder="correo@ejemplo.cl"
                            autocomplete="username"
                            name="email"
                            ref="email"
                            v-model="user.email"
                            rules="required|email|max:250"
                            disabled
                        />
                    </div>
                    <div>
                        <label class="label has-text-weight-bold" for="empresa">
                            Nombre de la Empresa
                        </label>
                        <Input
                            type="text"
                            placeholder="Ejemplo Ltda."
                            name="empresa"
                            ref="company_name"
                            v-model="user.company_name"
                            input-id="empresa"
                            rules="required|min:1|max:149"
                        />
                    </div>
                    <div>
                        <label class="label has-text-weight-bold" for="country">
                            País
                        </label>
                        <b-select disabled v-model="country" name="country" expanded>
                            <option
                                v-for="option in countriesList"
                                :value="option.name"
                                :key="option.id"
                            >
                                {{ option.name }}
                            </option>
                        </b-select>
                    </div>
                    <div>
                        <label class="label has-text-weight-bold" for="rut">
                            {{
                                country === "Chile" ? "Rut de la Empresa" : "Identificador empresa"
                            }}
                        </label>
                        <Input
                            v-if="country === 'Chile'"
                            rules="required|min:11|max:12|rut"
                            type="text"
                            placeholder="12.345.678-9"
                            input-id="rut"
                            name="rut"
                            ref="rut"
                            v-model="user.company_rut"
                            v-mask="rutMask"
                        />
                        <b-input
                            name="Identificador empresa"
                            data-testid="businessID"
                            class="has-icons-right"
                            v-else
                            placeholder="12.345.678-9"
                            v-model="businessID"
                        ></b-input>
                    </div>
                    <div>
                        <label class="label has-text-weight-bold" for="password">
                            Clave
                        </label>
                        <Input
                            rules="required|password_length"
                            type="password"
                            ref="password"
                            name="password"
                            minlength="4"
                            maxlength="64"
                            vid="password"
                            v-model="user.password"
                            autocomplete="current-password"
                            :is-password="true"
                            :safe-password="true"
                        />
                    </div>
                    <div>
                        <label class="label has-text-weight-bold" for="password">
                            Repetir Clave
                        </label>
                        <Input
                            rules="required|confirmed:password"
                            name="password"
                            type="password"
                            v-model="password_confirmation"
                            :is-password="true"
                        />
                    </div>
                    <div
                        class="is-block has-text-left mt-5 mb-1"
                        style="grid-column-end: 3; grid-column-start: 1;"
                    >
                        <CheckBox :rules="{ required: { allowFalse: false } }">
                            <b-checkbox v-model="checkTerms">
                                Acepto los
                                <a
                                    :href="
                                        `http://${publicPath}/pdf/Politicas_Privacidad_CFO_App.pdf`
                                    "
                                    download
                                    target="_blank"
                                >
                                    Términos y Condiciones
                                </a>
                            </b-checkbox>
                        </CheckBox>
                    </div>
                    <button
                        style="grid-column-end: 3; grid-column-start: 1;"
                        class="button is-fullwidth is-income"
                        :disabled="loading"
                        v-on:click.prevent="handleSubmit(submitForm)"
                    >
                        Crear Cuenta
                    </button>
                </ValidationObserver>
            </div>
        </main>
        <footer class="has-background-black has-text-white py-5">
            <div class="container">
                <p class="is-size-7">
                    <span class="has-text-weight-bold">Plan Basic</span>
                    Documentos automáticos del SII / Resultados de Ventas, Costos y Gastos /
                    Proyección de Caja / Financiamiento / Saldos y movimientos bancarios manuales.
                </p>
                <p class="is-size-7 my-4">
                    <span class="has-text-weight-bold">Plan Pro</span>
                    Documentos automáticos del SII / Resultados de Ventas, Costos y Gastos /
                    Proyección de Caja / Financiamiento / Saldos y movimientos bancarios
                    automáticos. (cada conexión a Cuentas Bancarias por 0.4 UF + IVA al mes)
                </p>
                <p>
                    Aplican
                    <a
                        :href="`http://${publicPath}/pdf/Politicas_Privacidad_CFO_App.pdf`"
                        download
                        target="_blank"
                        class="has-text-white is-underlined"
                    >
                        Términos y Condiciones
                    </a>
                </p>
            </div>
        </footer>
    </main>
</template>

<script>
import { mapActions, mapState, mapMutations } from "vuex";
import Logo from "@/components/svg/Logo.vue";
import chitaLogo from "@/assets/images/logochita.png";
import illustration from "@/assets/images/Ilustracion_1.png";
import { ValidationObserver } from "vee-validate";
import Input from "@/components/inputs/Input";
import CheckBox from "@/components/inputs/CheckBox";
import countriesList from "./countriesList";
import SegmentAnalytics from "@/utils/segmentAnalytics";
import { consoleHandlerError } from "@/utils/message";

export default {
    name: "RegisterChita",
    components: {
        Logo,
        Input,
        CheckBox,
        ValidationObserver,
    },
    data() {
        return {
            chitaLogo: chitaLogo,
            illustration: illustration,
            publicPath: window.location.hostname,
            countriesList: countriesList,
            errors: [],
            checkTerms: false,
            loading: false,
            password_confirmation: "",
            rutMask: ["#.###.###-B", "##.###.###-B"],
            country: "Chile",
            user: {
                first_name: this.$route.query.first_name,
                last_name: this.$route.query.last_name,
                email: this.$route.query.email,
                username: "",
                company_name: "",
                company_rut: "",
                password: "",
                token: this.$route.query.token,
            },
        };
    },
    created() {
        this.SET_PROMOTIONAL_TOKEN(this.$route.query.token);
        this.callValidatePromotionalToken(this.$route.query.token).catch(() => {
            this.$router.push("/register");
        });
    },
    methods: {
        ...mapActions("userAuth", ["callValidatePromotionalToken", "registerUser"]),
        ...mapMutations("userAuth", ["SET_PROMOTIONAL_TOKEN"]),
        submitForm() {
            if (this.country === "Chile") {
                this.loading = true;
                this.user.username = this.user.email;
                this.user.company_rut = this.user.company_rut.replaceAll(".", "");
                this.registerUser(this.user)
                    .then((user) => {
                        new SegmentAnalytics(user).trackSignUp();
                        this.$router.push("/confirm");
                    })
                    .catch((error) => {
                        this.loading = false;
                        consoleHandlerError({
                            error,
                            refFields: this.$refs,
                        });
                    });
            }
        },
    },
    computed: {
        ...mapState("userAuth", ["promotionalToken"]),
    },
};
</script>
